import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { getCookie } from "helpers";

const useAppTrue = (exceptions = []) => {
  const router = useRouter();
  const asPathWithoutQuery = router.asPath.split("?")[0];
  const [isApp, setIsApp] = useState(router.query.app === "true" && !exceptions.includes(asPathWithoutQuery));

  useEffect(() => {
    let date = new Date();
    date.setTime(date.getTime() + (60 * 60 * 1000));
    if(exceptions.includes(asPathWithoutQuery)) {
      return;
    }
    if (router.query.app === "true") {
      setIsApp(true);
      document.cookie = `app=true; expires=${date.toUTCString()}; path=/`;
    } else if (getCookie("app") === "true") {
      setIsApp(true);
    }
  }, []);

  return isApp;
};
export default useAppTrue;